import { find as _find } from 'lodash';
import { get, put, post } from './fetch'

export const getSellerServices = () => {
  return get(`/api/seller/services`);
}

export const getServicePrice = (serviceId) => {
  const servicePrices = [
    { serviceId: 1, minPrice: 10, maxPrice: 50 },
    { serviceId: 2, minPrice: 20, maxPrice: 60 },
    { serviceId: 3, minPrice: 15, maxPrice: 40 }
  ];
  return Promise.resolve(_find(servicePrices, (s) => s.serviceId == serviceId));
}

export const updateServicePrice = (serviceId, price) => {
  price = _.pick(price, ['priceMin', 'priceMax']);
  return put(`/api/seller/services/${serviceId}`, price);
}

export const getServiceList = (phrase) => {

  return post(`/api/services/search/basic/`, { "searchTerm": phrase }, false);

}

export const getTopPageServices = () => {
  const result = get(`/api/services/toppage`, false);
  return result;
}

export const getServiceRequestForm = (serviceId) => {
  return get(`/api/services/${serviceId}/form`, false);
}

export const getServiceRequestFormByName = (categoryName, serviceName) => {
  return get(`/api/services/${categoryName}/${serviceName}/form`, false);
}

export const getServiceById = (serviceId) => {
  return get(`/api/services/${serviceId}`, true);
}

export const getAllCategoryServices = (categoryID) => {
  return get(`/api/categories/${categoryID}/services`, false);
}

export const getServiceByName = (categorySEOName, serviceSEOName) => {
  return get(`/api/services/${categorySEOName}/${serviceSEOName}`, false);
}

export const getServiceSellersByLocation = (serviceID, lat, lng) => {
  return get(`/api/services/${serviceID}/sellers/${lat}/${lng}`, false);
}

export const getTopServices = () => {
  const result = get(`/api/services/top`, false);
  return result;
}

export const getServiceRequestDetails = (serviceRequestId) => {
  return get(`/api/buyer/request/${serviceRequestId}/detail`, true);
}

export const getNearByRequestServiceSubscribedSellers = (serviceID, lat, lng) => {
  return get(`/api/manager/service/${serviceID}/nearbysellers/${lat}/${lng}`, true);
}

export const getNearByRequestServiceSellers = (serviceID, lat, lng) => {
  return get(`/api/manager/service/${serviceID}/nearbysellers/${lat}/${lng}/all`, true);
}

// export const getNearByRequestServiceCancelledSellers = (serviceID, lat, lng) => {
//   return get(`/api/manager/service/${serviceID}/nearbysellers/${lat}/${lng}/cancelled`, true);
// }

export const getNearByRequestServiceSellersBySubStatus = (serviceID, lat, lng, subStatus) => {
  return get(`/api/manager/service/${serviceID}/nearbysellers/${lat}/${lng}/${subStatus}`, true);
}